import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent implements OnInit {

  /**
  * The text content of drawer title
  */
  @Input() heading: string;
  /**
  * Event emitted when the drawer is opened
  */
  @Output() onOpen: EventEmitter<any> = new EventEmitter();
  /**
  * Event emitted when the drawer is closed
  */
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  /**
  * Whether the drawer is open or closed
  */
  private _drawerOpen: boolean = false;
  get drawerOpen(): boolean  {
    return this._drawerOpen;
  }
  set drawerOpen(value: boolean) {
    this._drawerOpen = value;
    if (this._drawerOpen) {
      this.onOpen.emit();
    } else {
      this.onClose.emit();
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

  /**
  * Open the drawer
  */
  public openDrawer(event?: any) {
    if (event?.preventDefault) {
      event.preventDefault();
    }
    this.drawerOpen = true;
    this.onOpen.emit('open');
    document.documentElement.classList.add('drawer-open');
  }

  /**
  * Close the drawer
  */
  public closeDrawer(event?: any) {
    if (event?.preventDefault) {
      event.preventDefault();
    }
    this.drawerOpen = false;
    this.onClose.emit('close');
    document.documentElement.classList.remove('drawer-open');
  }

}
